import { PERMISSIONS } from '~/constants/permissions.constants';

export const checkForPermissions = (permissions) => {
  if (!permissions) return false;

  const { pathname } = window.location;

  // Settings - Acesso
  if (pathname === '/configuracoes/usuarios') {
    return permissions.includes(PERMISSIONS.users.view);
  }
  if (pathname === '/configuracoes/permissoes') {
    return permissions.includes(PERMISSIONS.settings.permissoes.view);
  }

  // Settings - Empresa
  if (pathname.startsWith('/configuracoes/empresa')) {
    return permissions.includes(PERMISSIONS.settings.empresa.view);
  }

  // Settings - Sistema
  if (pathname.startsWith('/configuracoes/tarefas-do-checklist')) {
    return permissions.includes(PERMISSIONS.settings.checklistTasks.view);
  }
  if (pathname.startsWith('/configuracoes/cadastro-de-tarefas')) {
    return permissions.includes(PERMISSIONS.settings.taskRegistration.view);
  }
  if (pathname === '/configuracoes/mensalidades') {
    return permissions.includes(PERMISSIONS.settings.monthlyModule.view);
  }
  if (pathname.startsWith('/configuracoes/variaveis/docs/')) {
    return permissions.includes(PERMISSIONS.settings.sporadicDocs.view);
  }
  if (pathname.startsWith('/configuracoes/variaveis/')) {
    return permissions.includes(PERMISSIONS.settings.systemVariables.view);
  }

  // Settings - Integrações
  if (pathname === '/configuracoes/whatsapp-por-departamento' ||
      pathname === '/configuracoes/wpp') {
    return permissions.includes(PERMISSIONS.settings.integracoes.view);
  }

  // Gestão
  if (pathname === '/clientes') {
    return permissions.includes(PERMISSIONS.customers.view);
  }
  if (pathname === '/solicitacoes') {
    return permissions.includes(PERMISSIONS.solicitations.view);
  }

  // Tarefas
  if (pathname.startsWith('/calendario')) {
    return permissions.includes(PERMISSIONS.calendarTasks.view);
  }
  if (pathname === '/tarefas') {
    return permissions.includes(PERMISSIONS.calendarTasks.create);
  }
  if (pathname === '/checklist') {
    return permissions.includes(PERMISSIONS.checklist.view);
  }
  if (pathname === '/conferencia') {
    return permissions.includes(PERMISSIONS.conference.view);
  }
  if (pathname === '/convencoes') {
    return permissions.includes(PERMISSIONS.conventions.view);
  }

  // Financeiro
  if (pathname === '/financeiro/mensalidades') {
    return permissions.includes(PERMISSIONS.financial.monthlyPayments.view);
  }
  if (pathname === '/financeiro/extras') {
    return permissions.includes(PERMISSIONS.extraServices.view);
  }
  if (pathname === '/financeiro/comissoes') {
    return permissions.includes(PERMISSIONS.refunds.view);
  }
  if (pathname === '/financeiro/contas-a-pagar') {
    return permissions.includes(PERMISSIONS.financial.contasPagar.view);
  }
  if (pathname === '/financeiro/conciliacao') {
    return permissions.includes(PERMISSIONS.financial.bankReconciliation.view);
  }
  if (pathname === '/financeiro/bancos') {
    return permissions.includes(PERMISSIONS.financial.bancos.view);
  }

  // Compliance - Societário
  if (pathname === '/societario' || pathname.startsWith('/societario/')) {
    return permissions.includes(PERMISSIONS.corporate.view);
  }
  if (pathname === '/certificados') {
    return permissions.includes(PERMISSIONS.certificates.view);
  }
  if (pathname === '/lembretes') {
    return permissions.includes(PERMISSIONS.procurations.view);
  }

  // Compliance - Fiscal
  if (pathname === '/IRPF') {
    return permissions.includes(PERMISSIONS.irpf.view);
  }
  if (pathname.startsWith('/malha-fina')) {
    return permissions.includes(PERMISSIONS.irpf.malhaFina.view);
  }
  if (pathname === '/dividas-tributarias') {
    return permissions.includes(PERMISSIONS.irpf.dividasTributarias.view);
  }

  // Comercial
  if (pathname === '/crm/leads') {
    return permissions.includes(PERMISSIONS.leads.view);
  }
  if (pathname.startsWith('/crm/prospeccao')) {
    return permissions.includes(PERMISSIONS.prospecting.view);
  }
  if (pathname.startsWith('/crm/social-selling')) {
    return permissions.includes(PERMISSIONS.socialSelling.view);
  }
  if (pathname === '/crm/indicacao-premiada') {
    return permissions.includes(PERMISSIONS.referralProgram.view);
  }
  if (pathname === '/recuperacao-tributaria') {
    return permissions.includes(PERMISSIONS.leadsRT.view);
  }
  if (pathname.startsWith('/v2/leads/inss_obra')) {
    return permissions.includes(PERMISSIONS.leadsRT.view);
  }
  if (pathname === '/boards' || pathname.startsWith('/marketing/')) {
    return permissions.includes(PERMISSIONS.boards.view);
  }

  // Relatórios
  if (pathname === '/relatorios/inadimplentes') {
    return permissions.includes(PERMISSIONS.reports.defaulters);
  }
  if (pathname === '/relatorios/prazos') {
    return permissions.includes(PERMISSIONS.documentsDeadline.view);
  }
  if (pathname === '/relatorios/honorarios') {
    return permissions.includes(PERMISSIONS.honoraries.view);
  }
  if (pathname === '/relatorios/emails' || pathname === '/relatorios/emails/erros') {
    return permissions.includes(PERMISSIONS.sentEmails.view);
  }
  if (pathname === '/relatorios/kpis') {
    return permissions.includes(PERMISSIONS.feedbacks.view);
  }
  if (pathname === '/relatorios/socios') {
    return permissions.includes(PERMISSIONS.reports.partners);
  }

  // Recursos
  if (pathname.startsWith('/items-enviados/documentos') || pathname === '/documentos') {
    return permissions.includes(PERMISSIONS.documents.view);
  }
  if (pathname.startsWith('/items-enviados/emails')) {
    return permissions.includes(PERMISSIONS.sentEmails.view);
  }
  if (pathname === '/plugins' || pathname === '/plugins/forms' || pathname === '/plugins/click-counter') {
    return permissions.includes(PERMISSIONS.plugins.view);
  }
  if (pathname === '/base-de-conhecimento') {
    return permissions.includes(PERMISSIONS.knowledgeBase.view);
  }
  if (pathname === '/links') {
    return permissions.includes(PERMISSIONS.links.view);
  }

  return true;
};
